$(document).ready(function(){
  var shopify_options = $('#infiniteoptions-container').data('shopify-options');
  if(shopify_options != null) {
    var interval = setInterval(function(){
      if($('.is-product-main .spb-label-tooltip .spb-productdescfont').length){
        clearInterval(interval);
        $('.is-product-main .spb-label-tooltip .spb-productdescfont').each(function(){
          shopify_options = shopify_options + 1;
          $(this).prepend('<span class="notranslate indicator_number">'+shopify_options+'</span>')
        });
        shopify_options = shopify_options + 1;
        $('.qty_indicator_num').html(shopify_options);
      }
    },200);
  }
});

/* ==================================================================
   FP - folha de estilo propria. O custom.js entra com "defer" no <head>,
   portanto isto corre antes da primeira pintura: nao ha salto de layout.
   ================================================================== */
(function () {
  var css = '';

  /* --- FP v40: banner de cookies mais pequeno no telemovel (65% -> ~27%) --- */
  css += '@media (max-width: 767px) {'
    + '  .shopify-pc__banner__dialog { padding: 12px 14px 10px !important; }'
    + '  .shopify-pc__banner__dialog h2, .shopify-pc__banner__dialog [id*="body-title"] { font-size: 14px !important; line-height: 1.2 !important; margin: 0 0 5px !important; }'
    + '  .shopify-pc__banner__dialog p, .shopify-pc__banner__dialog [id*="body-description"] { font-size: 11.5px !important; line-height: 1.3 !important; margin: 0 0 8px !important; }'
    + '  .shopify-pc__banner__dialog *:has(> button.shopify-pc__banner__btn-accept) { display: flex !important; flex-direction: row !important; flex-wrap: wrap !important; gap: 8px !important; align-items: stretch !important; }'
    + '  .shopify-pc__banner__dialog button { font-size: 13px !important; padding: 9px 8px !important; margin: 0 !important; min-height: 0 !important; }'
    + '  .shopify-pc__banner__dialog button.shopify-pc__banner__btn-accept, .shopify-pc__banner__dialog button.shopify-pc__banner__btn-decline { flex: 1 1 40% !important; width: auto !important; }'
    + '  .shopify-pc__banner__dialog button.shopify-pc__banner__btn-manage-prefs { flex: 1 1 100% !important; width: auto !important; font-size: 12px !important; padding: 4px !important; }'
    + '}';

  /* ------------------------------------------------------------------
     FP v45 (03/09/2026) - meios de pagamento SO NA PAGINA DO CARRINHO.

     O v44 punha esta linha tambem por baixo do "Adicionar ao carrinho".
     A Ana viu no telemovel e tem razao: nessa zona ja esta a mensagem de
     "Feita por encomenda..." (v39), e duas linhas de letra miuda a volta
     do botao sao ruido. RETIRADO da pagina de produto.

     Fica so no carrinho, onde a duvida "aceitam MB WAY?" pesa mesmo -
     imediatamente antes de Finalizar compra.

     PORQUE existe: a app do Eupago mudou de versao a 24/08 e o MB WAY e o
     Multibanco deixaram de ter nome proprio no checkout (aparecem como
     "Eupago Payments Gateway", em ultimo lugar, depois do Klarna).
     Metade das encomendas em Portugal usa esses dois meios. O Eupago diz
     que ainda nao consegue mudar (depende de autorizacao da Shopify).

     COMO: CSS puro com ::after sobre o formulario do carrinho. Nao insere
     elementos por JavaScript, logo nao empurra a pagina.
     form[action$="/cart"] e convencao da Shopify e cobre tambem os
     enderecos traduzidos (/en/cart). Se nao existir, nao aparece nada.

     FP v46 (04/09/2026): juntou-se o APPLE PAY a linha portuguesa. 56%
     do trafego movel da loja e iPhone e o Apple Pay estava a faltar
     exactamente onde mais conta. A ordem segue o peso real das
     encomendas em Portugal: MB WAY e Multibanco primeiro.
  ------------------------------------------------------------------ */
  css += 'form[action$="/cart"]::after {'
    + '  display: block;'
    + '  margin: 12px 0 0;'
    + '  font-size: 12px;'
    + '  line-height: 1.4;'
    + '  letter-spacing: .2px;'
    + '  text-align: center;'
    + '  color: #421414;'
    + '  opacity: .85;'
    + '}';
  css += 'html[lang^="pt"] form[action$="/cart"]::after {'
    + '  content: "Pagamento seguro \\2014 MB WAY \\00B7 Multibanco \\00B7 Cart\\00E3o \\00B7 Apple Pay \\00B7 PayPal \\00B7 Klarna";'
    + '}';
  css += 'html:not([lang^="pt"]) form[action$="/cart"]::after {'
    + '  content: "Secure payment \\2014 Card \\00B7 PayPal \\00B7 Apple Pay \\00B7 Klarna";'
    + '}';

  /* --- FP v46: caixa de "Ordenar por" da pagina de pesquisa.
     O estilo vive aqui (e nao junto do JS) para entrar antes da primeira
     pintura: quando a caixa e inserida ja encontra as regras prontas e
     nao ha um instante de select por estilar. --- */
  css += '.fp-ordena-pesquisa {'
    + '  display: flex;'
    + '  align-items: center;'
    + '  justify-content: center;'
    + '  flex-wrap: wrap;'
    + '  gap: 8px;'
    + '  margin: 0 0 18px;'
    + '}';
  css += '.fp-ordena-pesquisa__rotulo {'
    + '  font-size: 13px;'
    + '  letter-spacing: .4px;'
    + '  color: #421414;'
    + '  opacity: .8;'
    + '  margin: 0;'
    + '}';
  css += '.fp-ordena-pesquisa__select {'
    + '  font-size: 14px;'
    + '  padding: 8px 30px 8px 10px;'
    + '  min-height: 44px;'
    + '  max-width: 100%;'
    + '  color: #421414;'
    + '  background-color: #ffffff;'
    + '  border: 1px solid #cccccc;'
    + '  border-radius: 4px;'
    + '}';


  /* --- FP v51 (06/09/2026): a caixa "Ordenar por" das coleccoes com a MESMA
     letra e a MESMA cor dos filtros (Material, Preco). O styles.css do tema
     poe-lhe maiusculas, espacamento largo e a cor "Collection filters"; os
     filtros do bloco Faceted filtering usam a letra normal e a cor "Sidebar
     links". Aqui igualam-se: a cor le-se da definicao dos filtros, por isso
     se a Ana mudar a cor dos filtros no editor, a caixa acompanha. --- */
  css += 'body .section_select select.sort_by, body select#sort-by {'
    + '  font-family: inherit !important;'
    + '  font-size: 15px !important;'
    + '  font-weight: 400 !important;'
    + '  text-transform: none !important;'
    + '  letter-spacing: 0 !important;'
    + '  color: #254F2A !important;'
    + '}';
  var s = document.createElement('style');
  s.setAttribute('data-fp', 'fp-estilos');
  s.appendChild(document.createTextNode(css));
  (document.head || document.documentElement).appendChild(s);
})();

/* FP v42 - telefone do cabecalho clicavel (so no cabecalho, uma vez). */
(function () {
  var NUM = '920018184', BONITO = '920 018 184', TEL = 'tel:+351920018184', feito = false;
  function zonas() {
    try { return document.querySelectorAll('header, .header, #header, .top-bar, .top_bar, [class*="top-bar"], [class*="site-header"], [class*="header-"]'); }
    catch (e) { return []; }
  }
  function tornarClicavel() {
    if (feito) return;
    var zs = zonas();
    for (var z = 0; z < zs.length; z++) {
      var w = document.createTreeWalker(zs[z], NodeFilter.SHOW_TEXT, null, false), no;
      while ((no = w.nextNode())) {
        if (!no.nodeValue || no.nodeValue.indexOf(NUM) === -1) continue;
        var pai = no.parentNode;
        if (!pai || !pai.closest) continue;
        if (pai.closest('a')) { feito = true; return; }
        if (pai.closest('script, style, textarea, select')) continue;
        var t = no.nodeValue, i = t.indexOf(NUM);
        var a = document.createElement('a');
        a.href = TEL; a.textContent = BONITO;
        a.setAttribute('data-fp', 'tel');
        a.setAttribute('aria-label', 'Ligar para 920 018 184');
        a.style.color = 'inherit'; a.style.textDecoration = 'none'; a.style.whiteSpace = 'nowrap';
        pai.insertBefore(document.createTextNode(t.slice(0, i)), no);
        pai.insertBefore(a, no);
        pai.insertBefore(document.createTextNode(t.slice(i + NUM.length)), no);
        pai.removeChild(no);
        feito = true; return;
      }
    }
  }
  function arrancar() {
    tornarClicavel();
    setTimeout(function () { feito = false; tornarClicavel(); }, 1500);
    if (window.InstantClick && window.InstantClick.on) {
      try { window.InstantClick.on('change', function () { feito = false; tornarClicavel(); }); } catch (e) {}
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', arrancar, { once: true });
  else arrancar();
})();

/* FP v43 - "Ordenar por" com 4 opcoes em vez de 9. A opcao ACTIVA nunca e
   removida, para a caixa nunca mentir sobre a ordem da coleccao. */
(function () {
  var NOMES_PT = {
    'best-selling': 'Mais vendidos',
    'created-descending': 'Novidades',
    'price-ascending': 'Preços mais baixos',
    'price-descending': 'Preços mais altos'
  };
  var MANTER = ['best-selling', 'created-descending', 'price-ascending', 'price-descending'];
  function ePortugues() {
    var l = (document.documentElement.getAttribute('lang') || '').toLowerCase();
    return l.indexOf('pt') === 0;
  }
  function arrumar() {
    var sel = document.getElementById('sort-by') || document.querySelector('select.sort_by');
    if (!sel || sel.getAttribute('data-fp-sort') === '1') return;
    var activo = sel.value, pt = ePortugues();
    Array.prototype.slice.call(sel.options).forEach(function (op) {
      var v = op.value;
      if (MANTER.indexOf(v) !== -1) { if (pt && NOMES_PT[v]) op.textContent = NOMES_PT[v]; }
      else if (v !== activo) { if (op.parentNode) op.parentNode.removeChild(op); }
    });
    sel.value = activo;
    sel.setAttribute('data-fp-sort', '1');
  }
  function arrancar() {
    arrumar(); setTimeout(arrumar, 800); setTimeout(arrumar, 2000);
    if (window.InstantClick && window.InstantClick.on) {
      try { window.InstantClick.on('change', arrumar); } catch (e) {}
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', arrancar, { once: true });
  else arrancar();
})();

/* ==================================================================
   FP v46 (04/09/2026) - "Ordenar por" na PAGINA DE PESQUISA.

   PORQUE: em /search?q=... nao ha caixa de ordenacao nenhuma. A seccao
   "Search" do Turbo (sections/search-template.liquid) nunca teve a
   definicao collection_sort, ao contrario da seccao de coleccao. Quem
   pesquisa "pulseiras" recebe 216 resultados por ordem que nao controla.
   No Search & Discovery, 9 das 11 pesquisas de "pulseiras" nos ultimos
   30 dias terminaram SEM UM UNICO CLIQUE.

   O QUE FUNCIONA MESMO (medido na loja a 04/09/2026, nao adivinhado):
     ?sort_by=price-ascending   -> funciona
     ?sort_by=price-descending  -> funciona
     ?sort_by=best-selling      -> IGNORADO pela Shopify na pesquisa
     ?sort_by=created-descending-> IGNORADO pela Shopify na pesquisa
   Por isso ha TRES opcoes e nao quatro. Por "Mais vendidos" aqui era
   desenhar um botao que nao faz nada.

   AVISO HONESTO, para quem vier a seguir: a pesquisa da Shopify alarga
   os resultados alem do que tem mesmo a palavra (216 resultados para uma
   categoria de 142 pecas; ha brincos e medalhas la dentro). Por
   relevancia ficam no fim; em "Precos mais altos" sobem ao cimo. A cura
   disso nao e esta caixa - sao os FILTROS, que se ligam sem codigo em
   Personalizar -> Pesquisa -> Adicionar bloco -> Faceted filtering.

   CUIDADO COM O v43: aquele script apanha "#sort-by" e "select.sort_by"
   e apaga-lhes as opcoes que nao conhece. Esta caixa NAO usa nenhum
   desses nomes de proposito, senao o v43 comia-lhe a opcao "relevance".
   ================================================================== */
(function () {
  var MARCA = 'data-fp-sort-pesquisa';
  var OPCOES = {
    pt: [['relevance', 'Mais relevantes'], ['price-ascending', 'Preços mais baixos'], ['price-descending', 'Preços mais altos']],
    en: [['relevance', 'Most relevant'], ['price-ascending', 'Price: low to high'], ['price-descending', 'Price: high to low']]
  };
  var ROTULO = { pt: 'Ordenar por', en: 'Sort by' };

  function lingua() {
    var l = (document.documentElement.getAttribute('lang') || '').toLowerCase();
    return l.indexOf('pt') === 0 ? 'pt' : 'en';
  }

  function ePaginaDePesquisa() {
    return location.pathname.indexOf('/search') !== -1;
  }

  function haResultados() {
    return !!document.querySelector('.product_row a[href*="/products/"], .product-list a[href*="/products/"], .product-block a[href*="/products/"], a.product_image[href*="/products/"]');
  }

  function desenhar() {
    if (!ePaginaDePesquisa()) return;
    if (document.querySelector('[' + MARCA + ']')) return;

    var cabecalho = document.querySelector('.search__header');
    if (!cabecalho) return;
    if (!haResultados()) return;

    var lg = lingua();
    var actual = 'relevance';
    try {
      var p = new URLSearchParams(location.search).get('sort_by');
      if (p) actual = p;
    } catch (e) {}

    var caixa = document.createElement('div');
    caixa.className = 'fp-ordena-pesquisa';
    caixa.setAttribute(MARCA, '1');

    var rot = document.createElement('label');
    rot.className = 'fp-ordena-pesquisa__rotulo';
    rot.setAttribute('for', 'fp-ordenar-pesquisa');
    rot.textContent = ROTULO[lg];

    var sel = document.createElement('select');
    sel.className = 'fp-ordena-pesquisa__select';
    sel.id = 'fp-ordenar-pesquisa';

    var lista = OPCOES[lg], viuActual = false, i;
    for (i = 0; i < lista.length; i++) {
      var op = document.createElement('option');
      op.value = lista[i][0];
      op.textContent = lista[i][1];
      if (lista[i][0] === actual) { op.selected = true; viuActual = true; }
      sel.appendChild(op);
    }
    /* Se a pagina vier com uma ordenacao que nao esta na lista (por exemplo
       title-ascending, escrito a mao no endereco), acrescenta-se em vez de
       a esconder: a caixa nunca deve mentir sobre a ordem que esta a ser
       mostrada. Foi a mesma regra do v43. */
    if (!viuActual) {
      var extra = document.createElement('option');
      extra.value = actual;
      extra.textContent = actual;
      sel.insertBefore(extra, sel.firstChild);
    }
    /* A seleccao faz-se DEPOIS de todas as opcoes estarem no <select>.
       Por .selected numa opcao ainda solta nao pega: ao inseri-la, o
       navegador recalcula e volta a escolher a primeira. Foi assim que o
       ensaio apanhou a caixa a dizer "Mais relevantes" numa pagina que
       estava ordenada por titulo. */
    sel.value = actual;

    sel.addEventListener('change', function () {
      var url;
      try {
        url = new URL(location.href);
        if (sel.value === 'relevance') url.searchParams.delete('sort_by');
        else url.searchParams.set('sort_by', sel.value);
        url.searchParams.delete('page');
      } catch (e) { return; }
      window.location.href = url.toString();
    });

    caixa.appendChild(rot);
    caixa.appendChild(sel);
    if (cabecalho.parentNode) cabecalho.parentNode.insertBefore(caixa, cabecalho.nextSibling);
  }

  function arrancar() {
    desenhar();
    setTimeout(desenhar, 700);
    setTimeout(desenhar, 2000);
    if (window.InstantClick && window.InstantClick.on) {
      try { window.InstantClick.on('change', desenhar); } catch (e) {}
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', arrancar, { once: true });
  else arrancar();
})();